import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { isDark } from '../../../../utils/color';
import BaseCell from '../base-cell/index';
import { createFormField } from './form-field';
import { clickOnButton } from '../../../../actions/chat-body';
import { getSubmitObjects } from '../../../../utils/formHelper.js';

class FormCell extends BaseCell {
  static propTypes = {
    formKey: PropTypes.string.isRequired,
    formData: PropTypes.object.isRequired,
    disabled: PropTypes.bool.isRequired,
    isUpdateForm: PropTypes.bool.isRequired,
  }

  handleSubmit(data) {
    const { onSubmitForm, formData, systemMessages, isUpdateForm } = this.props;

    const buttonAttribute = {
      type: 'postback-with-message',
      text: isUpdateForm ? systemMessages.formUpdated : systemMessages.formSubmitted,
      data: {
        nodeId: formData.nodeId,
        type: 'form',
        objects: getSubmitObjects(formData, data),
        conversion: formData.conversion,
      }
    };
    onSubmitForm(buttonAttribute);
  }

  render() {
    const { isBot, baseParams, iconSrc, disabled, formData, formKey, index, systemMessages, isUpdateForm } = this.props;
    const { textCellStyle } = this.getCellStyle({ isBot, baseParams, iconSrc });
    const formClassName = cn('cu-ui-message cu-ui-message-form', {
      'cu-ui-message-form--on-dark': isDark(baseParams.botPromptBackgroundColor)
    });

    const FormField = createFormField(formKey, formData.objects);

    return (
      <div className={formClassName}>
        <div className={'cu-ui-message-block cu-ui-text-count-data'} {...this.textCountCustomAttributes}>
          <div className={'cu-ui-message-content'}
            style={textCellStyle}
          >
            <FormField
              index={index}
              objects={formData.objects}
              submitButtonLabel={isUpdateForm ? systemMessages.updateForm : formData.submitButtonLabel}
              disabled={disabled}
              resetHidden={formData.resetHidden}
              systemMessages={systemMessages}
              onSubmit={d => this.handleSubmit(d)}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  systemMessages: state.chatRoot.systemMessages
});

const mapDispatchToProps = dispatch => ({
  onSubmitForm: bindActionCreators(clickOnButton, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(FormCell)
